/**
 * Archivo js que permite gestionar las rutas del modulo Prestadores
 */
/**
 * Definicion de la lista de rutas que estan dentro del modulo de Prestadores
 */
const prestadoresRouter = [
	{
		/** Definicion de la ruta "principal" del modulo de Prestadores */
		path: '/prestadores',
		/** DEfinicion del nombre de la ruta de Prestadores */
		name: 'prestadores',
		/** Definicion de la redireccion automatica cuando se selecciona el modulo de Prestadores */
		redirect: {
			name: 'tab-prestadores'
		},
		/** Definicion de la vista de Prestadores */
		component: () => import('@/views/prestadores/Prestadores.vue'),
		/** Definicion de los metadatos */
		meta: {
			requiresAuth: true
		},
		/** Definicion de las rutas anidadas en prestadores */
		children: [
			{
				path: 'prestadores',
				name: 'tab-prestadores',
				component: () => import('@/views/prestadores/TabPrestadores.vue'),
				meta: {
					requiresAuth: true
				}
				},
				{
					path: 'sedes',
					name: 'sedes',
					component: () => import('@/views/prestadores/Sedes.vue'),
					meta: {
						requiresAuth: true
					}
			}
		],
	}
]
export default prestadoresRouter;